import { include } from "named-urls";

const routes = {
  dashboard: "/",
  booking: "/booking",
  placeOrder: "/placeOrder",
  cart: "/cart",
  cartAddress: "/cartAddress",
  paymentMethod: "/paymentMethod",
  purchaseOrder: "/purchaseOrder",
  orders: include("/orders", {
    list: "",
    details: ":id",
    success: "success/:id",
  }),
  account: include("/account", {
    profile: "profile",
    orders: "orders",
    company: "company",
    address: "address",
  }),

  backOffice: include("/bo/", {
    dashboard: "",
    dashboard_new: include("dashboard/", {
      view: "",
      report: "report",
      details: "details",
    }),
    // analytics: include("analytics/", {
    //   view: "",
    // }),
    companies: include("companies/", {
      list: "",
      new: "new",
      details: include(":companyId/", {
        view: "",
        edit: "edit",
        pickupAddresses: include("pickupAddresses/", {
          list: "",
        }),
        billingAddresses: include("billingAddresses/", {
          list: "",
        }),
        users: include("users/", {
          list: "",
          new: "new",
          edit: ":userId/edit",
          view: ":userId",
        }),
        catalog: include("catalog/", {
          list: "",
          edit: "edit",
          add: "add",
        }),
      }),
    }),
    addresses: "addresses",
    users: "users",
    orders: include("orders/", {
      list: "",
      new: "new",
      payments: "payments",
      details: include(":orderId/", {
        view: "",
        serviceRequest: "serviceRequest",
      }),
    }),
    packages: include("packages/", {
      list: "",
      add: "add",
      details: include(":id/", {
        view: "",
        edit: "edit",
      }),
    }),
    catalog: include("catalog/", {
      master: "master",
      companies: "companies",
      tests: include("tests", {
        new: "new",
      }),
    }),
    labPartners: include("labPartners/", {
      list: "",
      new: "new",
      details: include(":labId/", {
        view: "",
        edit: "edit",
      }),
    }),
    logisticPartners: include("logisticPartners/", {
      list: "",
      new: "new",
      details: include(":logisticId/", {
        view: "",
        edit: "edit",
      }),
    }),
    samplers: include("samplers/", {
      list: "",
      details: include(":samplerId/", {
        edit: "edit",
      }),
    }),
    agencies: include("agencies/", {
      list: "",
    }),
    assets: include("assets/", {
      list: "",
      new: "new",
      details: include(":assetId/", {
        view: "",
      }),
    }),
  }),
  labs: include("/labPortal/", {
    dashboard: "",
    labDashboard: include("dashboard/", {
      view: "",
      details: include("details/", {
        commodityOrderDetails: "commodityOrder",
      }),
    }),
    orders: include("orders/", {
      list: "",
      details: include(":orderId/", {
        view: "",
        uploadReport: "uploadreport",
        reuploadReport: "reuploadreport",
        sampleReceived: "samplereceived",
      }),
    }),
    payments: "payments",
    reviewReports: include("review-reports/", {
      list: "",
      review: ":id",
    }),
  }),
  // resultValidator:include( "/result-validator/",{
  //  view:":id",
  //  searchById:"search"
  // })
};

export default routes;
